import React, { useState, useRef, useEffect } from "react";

import utils from "./utils";
import classes from "./index.module.css";
import RadioButton from "../../base-components/radio-button";
import Button from "../../base-components/button";
import TextInput from "../../base-components/text-input";
import { setUserCurrentScreen } from "../../redux/action/app";
import { updateUserProfile } from "../../redux/thunk/app.thunk";
import config from "../../config";
import { openCitizenship } from "../../navigators/routes";
import { useDispatch, useSelector } from "react-redux";
import List from "../../base-components/list";

const LiquidAssets = () => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.app.isLoading);
  const [error, setError] = useState(false);
  const [activeButton, setActiveButton] = useState("");

  const onSubmit = () => {
    setError(showErrorMessage);
    if (!showErrorMessage) {
      const filter = utils.RADIO_ITEMS.filter((t) => t.label === activeButton);
      const info = filter.length > 0 ? filter[0] : utils.RADIO_ITEMS[0];
      const min = info?.value?.min || 0;
      const max = info?.value?.max || 0;
      dispatch(
        updateUserProfile({
          liquidAssets: activeButton,
          liquidAssetsMin: min,
          liquidAssetsMax: max,
        })
      ).then(() => {
        dispatch(setUserCurrentScreen(config.routes.citizenship));
        openCitizenship();
      });
    }
  };

  const showErrorMessage = activeButton.length === 0;

  return (
    <div className={classes.Container}>
      <div className={classes.top}>
        <h2 className={classes.Heading}>{utils.LIQUID_ASSETS_HEADER}</h2>
      </div>
      <div className={classes.middle}>
        {utils.RADIO_ITEMS.map((item) => {
          return (
            <RadioButton
              text={item.label}
              isActive={activeButton === item.label}
              setActive={setActiveButton}
            />
          );
        })}
      </div>
      <div className={classes.bottom}>
        <Button
          //spacing={{ top: "medium", bottom: "medium" }}
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            height: "50px",
            alignItems: "center",
          }}
          loading={isLoading}
          state={undefined}
          action={onSubmit}
          disabled={error}
        >
          {utils.LIQUID_ASSETS_BUTTON_HEADING}
        </Button>
      </div>
    </div>
  );
};

export default LiquidAssets;
